import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { C2, C2_FONT } from './Table/C2UserTable';

const GoBackButton = ({ isRTL, onClick, style, light = false }) => {
    const { t } = useTranslation();
    const color = light ? C2.white : C2.violet;

    return (
        <div dir={isRTL === "rtl" ? "rtl" : "ltr"} style={{ ...style }}>
            <Button
                variant="text"
                onClick={onClick}
                startIcon={isRTL === "rtl" ? undefined : <ArrowBackIcon sx={{ fontSize: 18 }} />}
                endIcon={isRTL === "rtl" ? <ArrowBackIcon sx={{ fontSize: 18, transform: 'scaleX(-1)' }} /> : undefined}
                sx={{
                    color,
                    textTransform: 'none',
                    fontFamily: C2_FONT,
                    fontWeight: 700,
                    px: 0.5,
                    mb: 0.5,
                    opacity: light ? 0.92 : 1,
                    '&:hover': {
                        bgcolor: light ? 'rgba(251,250,254,0.12)' : 'rgba(100,17,237,0.06)',
                    },
                }}
            >
                <Typography
                    component="span"
                    sx={{
                        fontWeight: 700,
                        color: 'inherit',
                        fontFamily: C2_FONT,
                        fontSize: 14,
                        letterSpacing: 0.3,
                    }}
                >
                    {t("go_back") || "Regresar"}
                </Typography>
            </Button>
        </div>
    );
};

export default GoBackButton;
